module.exports = __webpack_public_path__ + "static/media/rsz_ethereum.5fe07521.webp";